import { useState } from 'react';
import { Alert, Button, Sheet, Stack, Typography } from '@mui/joy';
import { API_URL } from '../api';

const VAPID_PUBLIC_KEY = 'BABDBh5N_h8CYd-FEQaMHI0PiSzJV-axbKBF2dcLA-v6_B2E9_0IXSWryYTEqfF4CNTxJ5o8531JEOLHk77PXpk';
function vapidBytes(value) {
  const raw = atob(value.replace(/-/g, '+').replace(/_/g, '/') + '='.repeat((4 - value.length % 4) % 4));
  return Uint8Array.from(raw, c => c.charCodeAt(0));
}
function deadline(promise, ms) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('Подключение заняло слишком долго. Проверьте сеть и попробуйте ещё раз.')), ms);
    promise.then(v => { clearTimeout(timer); resolve(v); }, e => { clearTimeout(timer); reject(e); });
  });
}
export default function RegistrationPushPrompt({ token }) {
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [connected, setConnected] = useState(false);
  if (!token) return null;
  const supported = window.isSecureContext && 'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window;
  const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const installed = navigator.standalone || window.matchMedia('(display-mode: standalone)').matches;
  async function connect() {
    setMessage('');
    if (!supported) { setMessage('Этот браузер не поддерживает PUSH. Результат можно уточнить у менеджера.'); return; }
    if (ios && !installed) { setMessage('На iPhone/iPad добавьте сайт на экран «Домой» и откройте его оттуда. Подключить PUSH также можно после входа в кабинет.'); return; }
    if (Notification.permission === 'denied') { setMessage('Уведомления запрещены. Разрешите их в настройках браузера, если хотите получать результат.'); return; }
    // Called synchronously from the click, before any network await.
    try {
      const permissionPromise = Notification.permission === 'granted'
        ? Promise.resolve('granted') : Notification.requestPermission();
      setBusy(true);
      if (await permissionPromise !== 'granted') { setMessage('Анкета отправлена. PUSH не подключены; это не влияет на рассмотрение.'); return; }
      await deadline(navigator.serviceWorker.register('/sw.js', { scope: '/' }), 15000);
      const registration = await deadline(navigator.serviceWorker.ready, 15000);
      let subscription = await deadline(registration.pushManager.getSubscription(), 15000);
      if (!subscription) subscription = await deadline(registration.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: vapidBytes(VAPID_PUBLIC_KEY) }), 15000);
      const response = await deadline(fetch(`${API_URL}/main/api/registration/push/`, {
        method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, subscription: subscription.toJSON() }),
      }), 15000);
      const data = await response.json();
      if (!response.ok) throw new Error(Array.isArray(data) ? data.join('; ') : data.detail || 'Не удалось подключить уведомления');
      setConnected(true); setMessage('Уведомления подключены. При рассмотрении анкеты отправим результат.');
    } catch (e) { setMessage(e.message || 'Не удалось подключить PUSH. Анкета уже отправлена.'); }
    finally { setBusy(false); }
  }
  return <Sheet variant="soft" sx={{ p: 2, borderRadius: 'lg', mb: 2 }}>
    <Stack spacing={1}><Typography level="title-md">Анкета отправлена</Typography>
      <Typography level="body-sm">После проверки вы сможете войти. Подключите уведомления, чтобы узнать результат.</Typography>
      {!supported && <Typography level="body-sm">Этот браузер не поддерживает PUSH. Анкета будет рассмотрена без уведомлений.</Typography>}
      {!connected && supported && <Button loading={busy} onClick={connect}>Сообщить мне результат</Button>}
      {message && <Alert color={connected ? 'success' : 'neutral'}>{message}</Alert>}
    </Stack>
  </Sheet>;
}